import { Box, SimpleGrid } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useTranslation } from 'react-i18next';

import { TextInput } from 'components';
import { CreditOptionsResponse, CreditRequestForm, CreditResponse } from 'types';

import CreditRequestPersonalAddress from './address';
import CreditRequestPersonalChildren from './children';
import CreditRequestPersonalInfo from './info';
import CreditRequestPersonalPartner from './partner';

interface CreditRequestPersonalProps {
  credit: CreditResponse;
  form: UseFormReturnType<CreditRequestForm>;
  options: CreditOptionsResponse;
  visibleFields: string[];
  readOnly?: boolean;
}

const CreditRequestPersonal = ({
  credit,
  form,
  options,
  visibleFields,
  readOnly = false,
}: CreditRequestPersonalProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <CreditRequestPersonalInfo form={form} options={options} visibleFields={visibleFields} readOnly={readOnly} />
      <CreditRequestPersonalAddress form={form} visibleFields={visibleFields} readOnly={readOnly} />
      <CreditRequestPersonalChildren credit={credit} form={form} options={options} readOnly={readOnly} />
      {visibleFields.includes('partnerOnSameAddress') && (
        <CreditRequestPersonalPartner form={form} options={options} visibleFields={visibleFields} readOnly={readOnly} />
      )}

      <Box p={'md'} mt={'sm'}>
        <SimpleGrid cols={4}>
          <TextInput
            label={t('credit.comment.singular')}
            key={form.key('comment2')}
            {...form.getInputProps('comment2')}
            disabled={readOnly}
          />
        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default CreditRequestPersonal;
